import { useEffect, useState } from 'react';
import * as S from './styled';
import { FormattedMessage } from 'react-intl';
import { useAppDispatch } from '../../redux/hooks';
import { getMessages, updateOrgStatus } from '../../redux/slices/notifications';
import { ApiMessageDisplay } from '@agunity/api-v4';
import CloseIcon from '@mui/icons-material/Close';
import AddNotifications from './AddNotifications';
import AgTypography from '../../stories/Styles/AgTypography';

const Notifications = () => {
  const showNotifications = true;
  const dispatch = useAppDispatch();
  const [messages, setMessages] = useState<ApiMessageDisplay[]>([]);

  const updateStatus = async (message: { id: number }) => {
    await dispatch(updateOrgStatus(message.id));
    const results = await dispatch(getMessages());
    if (results) {
      setMessages(results.data);
    }
  };

  useEffect(() => {
    const f = async () => {
      const results = await dispatch(getMessages());
      if (results) {
        setMessages(results.data);
      }
    };
    f();
  }, [dispatch]);

  if (!showNotifications) return <></>;
  return (
    <S.Container>
      <AgTypography
        component='div'
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
        <FormattedMessage id='NOTIFICATIONS' />
        <AddNotifications />
      </AgTypography>
      <S.Divider />
      {messages
        .filter((msg) => msg.status === 0)
        .map((message, index) => {
          const {
            status,
            subject,
            body,
            fromEMail,
            updatedAsOf,
            organizationName
          } = message;
          return (
            <div key={index}>
              {status === 0 && (
                <>
                  <S.NotificationStatus>
                    <S.From>
                      <span>{updatedAsOf}</span>
                      <br />
                      <span>
                        <FormattedMessage id='from' />
                      </span>{' '}
                      <a href={`mailto:${fromEMail}`}>{fromEMail}</a>
                      <span> @ {organizationName}</span>
                    </S.From>
                    <S.Close onClick={() => message?.id && updateStatus(message as { id: number })}>
                      <CloseIcon />
                    </S.Close>
                  </S.NotificationStatus>
                  <S.NotificationName>
                    {subject}
                  </S.NotificationName>
                  <S.NotificationDesc>
                    {body}
                  </S.NotificationDesc>
                  <S.Divider />
                </>
              )}
            </div>
          );
        })}
    </S.Container>
  );
};

export default Notifications;